import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
  const [categories, setCategories] = useState([]);
  const [settings, setSettings] = useState({
    store_name: 'Brookzone Bookseller',
    email: 'hello@brookzone.com',
    phone: '(555) 123-4567',
    address: '123 Bookstore Lane, Reading Town',
    about_text: 'Your cozy corner for books, crystals, incense, and more.'
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [catRes, settingsRes] = await Promise.all([
          axios.get(`${API}/categories`),
          axios.get(`${API}/settings`)
        ]);
        setCategories(catRes.data);
        setSettings(settingsRes.data);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <footer className="bg-primary text-primary-foreground" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
          {/* Brand */}
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-3 sm:mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_brookzone/artifacts/o226qsqt_ChatGPT%20Image%20Jan%204%2C%202026%2C%2007_21_15%20PM%20%281%29.png" 
                alt="Brookzone Bookseller" 
                className="h-8 w-8 sm:h-10 sm:w-10 object-contain"
              />
              <span className="font-serif text-lg sm:text-xl font-bold">{settings.store_name}</span>
            </Link>
            <p className="text-primary-foreground/80 mb-3 sm:mb-4 max-w-sm text-sm sm:text-base">
              {settings.about_text}
            </p>
            <div className="flex flex-col gap-1.5 sm:gap-2 text-xs sm:text-sm text-primary-foreground/70">
              <div className="flex items-center gap-2">
                <MapPin className="h-3.5 w-3.5 sm:h-4 sm:w-4 flex-shrink-0" />
                <span className="line-clamp-1">{settings.address}</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-3.5 w-3.5 sm:h-4 sm:w-4 flex-shrink-0" />
                <span>{settings.phone}</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-3.5 w-3.5 sm:h-4 sm:w-4 flex-shrink-0" />
                <span className="truncate">{settings.email}</span>
              </div>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h3 className="font-serif text-base sm:text-lg font-semibold mb-3 sm:mb-4">Categories</h3>
            <ul className="space-y-1.5 sm:space-y-2 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-base sm:text-lg font-semibold mb-3 sm:mb-4">Quick Links</h3>
            <ul className="space-y-1.5 sm:space-y-2 text-sm">
              <li>
                <Link to="/products" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/ebooks" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  E-books
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Journal / Blog
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/return-policy" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Return Policy
                </Link>
              </li>
              <li>
                <Link to="/donate" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Donate
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center text-xs sm:text-sm text-primary-foreground/60">
          <p>Brookzone Bookseller © 2026. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
